/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { dependencyItemCauseSummarySchema } from './dependencyItemCauseSummarySchema';
import { healthRiskSummarySchema } from './healthRiskSummarySchema';

export const itemsHealthMetricsSchema = z.object({
  averageProgressPercentage: z.int().nullish(),
  dependency: z.object({}).catchall(z.array(z.lazy(() => dependencyItemCauseSummarySchema))),
  healthLevels: z.object({}).catchall(z.int()),
  healthRisks: z.object({}).catchall(z.lazy(() => healthRiskSummarySchema)),
  missingData: z.object({}).catchall(z.array(z.int())),
  percentageDiff: z.number().nullish(),
  total: z.int(),
  totalActualSeconds: z.int(),
  totalPlanSeconds: z.int(),
});
